import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

export default function Index({ breadcrumbs }) {
  return (
    <div className="page-locations">
      {breadcrumbs.map((breadcrumb) => (
        <div className="item">
          {breadcrumb.path ? (
            <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
          ) : breadcrumb.name}
        </div>
      ))}
    </div>
  );
}

Index.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
